import { IAIConstructorOptions, IAIController, ShowOptions } from '@tencent/ai-sdk-interface';
import SlideApp from '@framework/docs-api/slide-app';
import SlideFeature from '@framework/docs-api/slide-feature';
import FileKit from '@framework/docs-api/file-kit';
import type { docs } from '@tencent/docs-api';
import {
    AIChannelOptions,
    IAiService,
    IAIServiceDelegates,
} from '@src/slide/application/service/ai/core/base/ai-service.interface';

export default abstract class BaseAiService implements IAiService {
    public aiSidebarController: IAIController;
    // service
    protected services?: IAIServiceDelegates;
    // AI侧边栏
    protected aiControllerLoader: Promise<void>;
    protected aiLifeCyclesFunction: IAIConstructorOptions['lifecycles'];

    protected constructor() {
        this.aiControllerLoader = this.initAISideBarController();
    }

    public async getSidebarController() {
        await this.aiControllerLoader;
        return this.aiSidebarController;
    }

    public async setChannelOptions(channelOptions: AIChannelOptions) {
        await this.aiControllerLoader;
        this.aiSidebarController.setChannelOptions(channelOptions);
    }

    // 显示侧边栏，注册监听
    public async showSideBar(options?: ShowOptions) {
        await this.aiControllerLoader;
        this.aiSidebarController.show(options);
    }

    // 关闭AI侧边栏，移除监听
    public async hideSideBar() {
        await this.aiControllerLoader;
        this.aiSidebarController.hide();
    }

    // 弹出推荐弹窗
    public async showRecommendCard() {
        await this.aiControllerLoader;
        // TODO: 类型修正
        (this.aiSidebarController as any).pushRecommendCommandsCard?.();
    }

    public setLifecycleFunction(lifecycles: IAIConstructorOptions['lifecycles']) {
        this.aiLifeCyclesFunction = lifecycles;
    }

    public setServiceDelegates(services: IAIServiceDelegates) {
        this.services = {
            ...this.services,
            ...services,
        };
    }

    protected registerDocsApi(api: typeof docs.api) {
        api.registerSlideApp(SlideApp.getInstance());
        api.registerSlideFeature(SlideFeature.getInstance());
        api.registerFileKit(FileKit.getInstance());
    }

    // 初始化AI侧边栏
    private async initAISideBarController(): Promise<void> {
        this.aiSidebarController = await this.createAIController();
    }

    protected abstract createAIController(): Promise<IAIController>;
}
